import React, { useState, useMemo } from 'react';
import css from './FilterSidebar.module.css';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';

const FollowersFilterSection = ({
  handleClearFilter,
  handleRadioChange,
  paramKey,
  selectedValues = [],
  isBlackBgFilter,
}) => {
  const followerRanges = [
    { value: '1000,10000', label: '1k - 10k' },
    { value: '10000,100000', label: '10k - 100k' },
    { value: '100000,1000000000000', label: '100k+' },
  ];

  const [searchTerm, setSearchTerm] = useState('');

  const selectedValueStr = Array.isArray(selectedValues)
    ? selectedValues.join(',')
    : selectedValues;

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  const filteredRanges = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    return followerRanges.filter(({ value, label }) => {
      const matchesLabel = label.toLowerCase().includes(term);

      const [min, max] = value.split(',').map(Number);
      const numTerm = Number(term);
      const matchesRange = !isNaN(numTerm) && numTerm >= min && numTerm < max;

      return matchesLabel || matchesRange;
    });
  }, [searchTerm]);

  return (
    <div className={css.ageFilterSection}>
      <FilterSectionHeader
        isBlackBgFilter={isBlackBgFilter}
        titleId="FilterCategories.followers"
        handleClear={handleClear}
      />

      <SearchInput
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="Search Followers..."
      />

      <div className={css.ageScrollable}>
        {filteredRanges.map(({ value, label }) => {
          const isChecked = selectedValueStr === value;
          return (
            <label key={value} className={css.ageRadioLabel}>
              <input
                type="radio"
                name={paramKey}
                value={value}
                checked={isChecked}
                onChange={e => handleRadioChange(e, paramKey)}
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default FollowersFilterSection;
